import React from 'react';
import { useSpring, animated } from 'react-spring';

function Fade({ toggle, children }) {
    const propsToAnim = [
        { display: toggle ? 'block' : 'none' },
        { opacity: toggle ? 1 : 0 },
    ];

    const styles = useSpring({ 
        to: toggle ? propsToAnim : propsToAnim.reverse()
    });
    
    return (
        <animated.div style={styles}>
            {children}
        </animated.div>
    );
}

export default Fade;